/**
 * Pannellum implementation for displaying 360 images.
 *
 * @author Vašek Brychta <vaclav@brychtovi.cz>
 * @version 2018-06-18
 */

(function (window, $, Foundation, undefined) {

	if (typeof $ !== 'function') {
		return console.error('brko.pannellum.js: jQuery is missing, load it please');
	}

	var pannellum = function () {
		this.options = {
			containerSelector: 'panorama'
		};

		/**
		 * Initialize pannellum.
		 *
		 * @param {object} options
		 * @param {string} options.containerSelector
		 * @returns {pannellum|undefined}
		 */
		this.init = function (options) {
			$.extend(this.options, options);

			if (this.options.containerSelector === undefined || this.options.containerSelector.length === 0) {
				return undefined;
			}
			if (!this.checkRequirements()) {
				return undefined;
			}

			this._containers = $(this.options.containerSelector);
			if (this._containers === undefined || this._containers.length === 0)
				return undefined;

			this._baseId = this._generateId();
			this._basePannellumOptions.basePath = $('body').data('base-path') + '/images/';
			this._containers.each(this._initializePanorama.bind(this));

			return this;
		};

		/**
		 * Basic sanity check before run.
		 *
		 * @returns {boolean}
		 */
		this.checkRequirements = function () {
			if (typeof window.pannellum !== 'object') {
				console.error('brko.pannellum.js: Pannellum library is missing, load it please');
				return false;
			}
			return true;
		};


		// region Inner properties

		this._P = window.pannellum;
		this._containers = undefined;
		this._baseId = undefined;
		this._basePannellumOptions = {
			type: 'equirectangular',
			autoLoad: true,
			autoRotate: -2,
			orientationOnByDefault: true,
			basePath: undefined
		};

		// endregion Inner properties


		// region Initialization

		this._initializePanorama = function (index, container) {
			var id = container.id;
			if (id === undefined || id.length === 0) {
				id = container.id = 'pano_' + this._baseId + '_' + index;
			}

			var options = this._basePannellumOptions;
			$.extend(options, {panorama: $(container).attr('src')});

			if ($(container).attr('northOffset') !== undefined)
			{
				$.extend(options, {compass: true, northOffset: +($(container).attr('northOffset'))});
			}

			this._P.viewer(id, options);
		};

		// dec2hex :: Integer -> String
		this._dec2hex = function (dec) {
  			return ('0' + dec.toString(16)).substr(-2);
		};

		// generateId :: Integer -> String
		this._generateId = function (len) {
			var crypto = window.crypto || window.msCrypto || {
    			getRandomValues: function (array) {
      				for (var i = 0, l = array.length; i < l; i++) {
        				array[i] = Math.floor(Math.random() * 256);
      				}
      				return array;
    			}
  			};

  			var arr = new Uint8Array((len || 10) / 2);
  			crypto.getRandomValues(arr);
  			return Array.from(arr, this._dec2hex).join('');
		};

		// endregion Initialization
	};

	if (window.brko === undefined) {
		window.brko = new (function () {
		});
	}

	/**
	 * Initialize pannellum.
	 *
	 * @param {object} options
	 * @param {string} options.containerSelector
	 * @returns {pannellum|undefined}
	 */
	window.brko.pannellum = function (options) {
		return new pannellum().init(options);
	};

})(window, window.jQuery, window.Foundation);
